<template>
  <div class="fx-header1" :style="titleStyle">
    <div class="head_left wrapper">
      <div v-for="(item,index) in submenuList.left" :key="index"
        :class="['sub',item.path===selectMenu.path?'selected':'']" @click="toMenu(item)">
        <i :class="item.Icon"></i>
        <span>{{item.text}}</span>
      </div>
    </div>
    <div class="head_title">{{headTitle}}</div>
    <div class="head_right wrapper">
      <div v-for="(item,index) in submenuList.right" :key="index"
        :class="['sub',item.path===selectMenu.path?'selected':'']" @click="toMenu(item)">
        <i :class="item.Icon"></i>
        <span>{{item.text}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "fxHeader1",
  data() {
    let currentMenu = this.$route;
    return {
      headTitle: "", //标题
      titleStyle: "", //header样式
      submenuList: {}, //子菜单
      selectMenu: "",
      currentMenu: currentMenu
    };
  },
  props: {
    config: {
      type: Object,
      default() {
        return {
          headTitle: "数据分析系统",
          titleStyle: {},
          submenuList: {
            left: [
              {
                num: 1,
                Icon: "fa fa-home fa-lg",
                text: "标题一",
                key: "",
                style: {}
              },
              {
                num: 2,
                Icon: "fa fa-home fa-lg",
                text: "标题2",
                key: "",
                style: {}
              }
            ],
            right: [
              {
                num: 1,
                Icon: "fa fa-home fa-lg",
                text: "标题一",
                key: "",
                style: {}
              },
              {
                num: 2,
                Icon: "fa fa-home fa-lg",
                text: "标题2",
                key: "",
                style: {}
              }
            ]
          }
        };
      }
    }
  },
  watch: {
    config() {
      this.loadData();
    }
  },
  methods: {
    loadData() {
      let { headTitle, titleStyle, submenuList } = this.config;

      if (headTitle) {
        this.headTitle = headTitle;
      }
      if (titleStyle) {
        this.titleStyle = titleStyle;
      }
      if (submenuList) {
        this.submenuList = submenuList;
        console.log("this.submenuList", this.submenuList);
      }

      let { currentMenu, selectMenu } = this;
      for (let key in submenuList) {
        submenuList[key].forEach(ele => {
          if (ele.path == currentMenu.path) {
            this.selectMenu = ele;
          }
        });
      }
      // if(currentMenu.query)
    },
    toMenu(menu) {
      this.selectMenu = menu;
      this.$router.push({
        path: menu.path,
        query: menu.query
      });
    }
  },
  mounted() {
    let self = this;
    this.$nextTick(() => {
      this.loadData();
    });
  }
};
</script>
<style lang="scss" scoped>
.fx-header1 {
  height: 70px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  color: #eeeeee;
  padding:0 10px;
  .wrapper {
    display: flex;
    .icon {
      padding-right: 8px;
    }
    .sub {
      padding: 5px;
      cursor: pointer;
    }
  }
  .head_left {
  }
  .head_title {
    font-size: 36px;
  }
}
.selected {
  color: #ffffff;
  border:1px solid rgb(124, 231, 253);
  border-radius: 6px;
  background: #06203e;
}
</style>
